import i18n from 'src/i18n';

const configTable = () => ({
  tableColumns: [
    { 
      prop: 'order', 
      label: i18n.t('common_words.order'), 
      sortable: true 

    },
    { 
      prop: 'name', 
      label: i18n.t('common_words.name'), 
      sortable: true 
    }
  ],
});

export default configTable;
